var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-my-3 gl-flex gl-items-center gl-gap-3",attrs:{"data-testid":"verification-divider"}},[_c('hr',{staticClass:"gl-grow gl-border-default"}),_vm._v(" "),_c('span',{staticClass:"gl-text-subtle"},[_vm._v(_vm._s(_vm.s__('TwoFactorAuth|or verify with')))]),_vm._v(" "),_c('hr',{staticClass:"gl-grow gl-border-default"})])
}
var staticRenderFns = []

export { render, staticRenderFns }